/**
 * Obtiene la fecha de expiración de un documento
 */
export const getExpirationLoanDoc = (loanDoc: any, loanDocs?: any[]): any => {
  const isLoanDoc = loanDocs?.find(item => item.key === loanDoc.key);
  return isLoanDoc?.expiration;
};

/**
 * Filtra para obtener solo los documentos de credit report y background check
 * y se remueven los que no deben mostrarse en processing (menos del 20% stake)
 */
export const filterGuarantors = (loanDocs: any[]): any[] => {
  const loanGuarantors = loanDocs?.filter(item => item.ownership?._id) || [];
  return loanGuarantors.filter((doc: any) => !doc.metadata?.hideFromProcessing);
};

/**
 * Formatea las opciones múltiples de insurance
 */
export const formatMultiple = (options: { docs?: boolean; agent?: boolean; obie?: boolean }): string => {
  const selected = [];
  if (options.docs) selected.push('documents');
  if (options.agent) selected.push('agent contact');
  if (options.obie) selected.push('Obie');
  
  if (selected.length === 0) return '';
  if (selected.length === 1) return selected[0];
  if (selected.length === 2) return `${selected[0]} and ${selected[1]}`;
  return `${selected[0]}, ${selected[1]}, and ${selected[2]}`;
};

/**
 * Determina si existen archivos previamente guardados en un loan doc
 */
export const hasPersistedFiles = (files?: any[]): boolean => {
  if (!Array.isArray(files)) return false;
  return files.some((file) => file?.url || file?.key);
};
